<template>
  <v-dialog v-model="open" scrollable persistent max-width="450px">
    <v-card>
      <v-card-title class="c-dialog-title">
        <div class="c-dlg-hd">
          <div class="c-flex ac">
            <div>
              <span class="c-dlg-ttl">{{ setting.title }}</span>
            </div>
            <div class="s"></div>
          </div>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-container grid-list-lg text-xs-left class="c-content-area">
        <v-layout column wrap>
          <v-flex>
            <div class="c-flex c-cover-area">
              <div class="c-explain">{{ setting.explain }}</div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout column wrap>
          <v-flex>
            <div class="c-flex c-cover-area">
              <div class="c-input">
                <v-select
                  :data-vv-name="setting.id"
                  :items="setting.items"
                  :item-text="setting.itemText"
                  :item-value="setting.itemValue"
                  :ref="`input_${setting.id}`"
                  :label="setting.inputLabel"
                  v-model="country"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('country')"
                  :required="true"
                  :disabled="loading"
                ></v-select>
              </div>
            </div>
            <div v-if="countryRules.length > 0" class="checks">
              <div v-for="rule in countryRules">
                <v-checkbox
                  color="clr-primary"
                  :label="rule.label"
                  :value="rule.value"
                  v-model="checked[rule.value]"
                  hide-details
                  :height="48"
                  :disabled="loading || isProhibitedAge"
                ></v-checkbox>
              </div>
            </div>
            <div v-if="ageError" class="c-errmsg clr-danger--text">
              {{ ageError }}
            </div>
            <div v-if="isProhibitedAge && !ageError" class="c-errmsg clr-danger--text">
              {{ $T('community.check_env.age_error') }}
            </div>
          </v-flex>
        </v-layout>

        <v-layout v-if="errMsg" column wrap>
          <v-flex class="c-errmsg">
            {{ errMsg }}
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="close" :disabled="loading">{{
          $T('button.close')
        }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="save" :disabled="!savable" :loading="loading">{{
          $T('button.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MemberApi from '../../api/member';
// {
//   id: 'country',
//   type: 'value-button',
//   title: this.$T('attributes.country'),
//   explain: this.$T('page.setting.country.explain'),
//   supplement: this.$T('page.setting.supplement.reload'),
//   value: '',
//   editValue: function(component, value) {
//     return $commin.countries(value).value;
//   },
//   disabled: false,
//   dialogType: 'select',
//   items: this.$commin.countries(),
//   itemText: 'value',
//   itemValue: 'key',
//   dialogTitle: this.$T('common.change_attribute', { attr: this.$T('attributes.country') }),
//   inputLabel: this.$T('attributes.country'),
//   veeValidate: '',
// },

export default {
  props: {
    setting: Object,
  },
  data() {
    const country = this.$store.state.user.country;

    return {
      initCountry: country,
      country,
      checked: {},
      age: -1,
      pastChecked: null,
      rules: null,
      open: true,
      loading: false,
      apiErrors: {},
      ageError: null,
      errMsg: null,
      inputDisabled: false,
    };
  },
  watch: {
    checked(n, o) {
      this.ageError = null;
    },
    country(n, o) {
      this.ageError = null;
    },
  },
  computed: {
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
    savable() {
      return !this.isProhibitedAge && !!this.rules && !this.isFormInValid && !this.loading;
    },
    editable() {
      return !!this.rules && !this.isFormInValid && !this.loading;
    },
    shouldOpen() {
      return !this.storeRuleChecked;
    },
    storeRuleChecked() {
      return this.$store.state.user.rule_checked;
    },
    countryRules() {
      if (!this.rules || !this.pastChecked) return [];

      let checkedAge = -1;
      for (const key of Object.keys(this.pastChecked)) {
        if (key.indexOf('_') == -1) {
          // when country level check record.
          const age = this.pastChecked[key];
          checkedAge = checkedAge == -1 ? age : checkedAge < age ? age : checkedAge;
        }
      }

      const rules = [];
      const countryRule = this.rules[this.country];
      if (countryRule) {
        if (countryRule.ALL) {
          const age = countryRule.ALL;
          const key = `${this.country}_${age}`;
          const checkedKey = this.country;
          if (this.age < age && !this.pastChecked[checkedKey] && age > checkedAge) {
            rules.push({
              value: key,
              label: $T('community.check_env.age_country', { age: age + 1 }),
            });
          }
        }
        if (countryRule.AREA) {
          for (const area of Object.keys(countryRule.AREA)) {
            const age = countryRule.AREA[area];
            const key = `${this.country}_${area}_${age}`;
            const checkedKey = `${this.country}_${area}`;
            if (this.age < age && !this.pastChecked[checkedKey] && age > checkedAge) {
              rules.push({
                value: key,
                label: $T('community.check_env.age_area', {
                  age: age + 1,
                  area: $T(`mst.area.${area}`),
                }),
              });
            }
          }
        }
      }
      return rules;
    },
    isProhibitedAge() {
      if (!this.rules || this.age == -1) return false;
      const rules = [];
      const countryRule = this.rules[this.country];
      if (!countryRule) return false;
      if (countryRule.ALL) {
        if (countryRule.ALL >= this.age) return true;
      }
      return false;
    },
  },
  mounted: function() {
    if (this.shouldOpen) {
      this.openDialog();
      (async () => {
        const rules = await MemberApi.getRules();
      })();
    }
    this.getRulesAndCurrentState();
  },
  methods: {
    async save() {
      this.loading = true;
      const result = await this.$validator.validateAll();
      if (result) {
        let checked = null;
        for (const rule of this.countryRules) {
          if (!this.checked[rule.value]) {
            this.ageError = $T('community.check_env.age_error');
            this.loading = false;
            return;
          } else {
            checked = checked ? `${checked},${rule.value}` : rule.value;
          }
        }
        await this.postData(checked);
      } else {
        this.loading = false;
        return;
      }
    },
    async postData(checked) {
      var data = new FormData();
      data.append('id', 'country');
      data.append('value', this.country);
      data.append('checked', checked);

      try {
        const response = await MemberApi.updateMemberSetting(data);
        this.loading = false;
        if (this.initCountry != this.country) {
          location.reload();
        } else {
          this.close();
        }
      } catch (e) {
        console.log(e);
        this.errMsg = $T('common.failed.register');
        this.loading = false;
      }
    },
    initFocus() {
      this.$nextTick(function() {
        this.$refs.name.focus();
      });
    },
    close() {
      this.$emit('close-dialog');
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] ? this.apiErrors[fieldName] : this.errors.collect(fieldName);
    },
    async getRulesAndCurrentState() {
      const rs = await MemberApi.getRulesAndState();

      console.warn(JSON.stringify(rs));

      this.pastChecked = rs.checked;
      this.age = rs.age;
      this.rules = rs.rules;
    },
    logout() {
      postForm('/logout', {});
    },
  },
};
</script>

<style scoped>
.container {
  padding: 16px 24px 20px 24px;
}
.le-tbs .container {
  padding: 16px 24px 20px 24px;
}
.c-content-area {
  min-height: 150px;
}
.c-input {
  flex-grow: 1;
}
.c-flex-container {
  display: flex;
  width: 250px;
}
.c-flex-container .l {
  width: 150px;
}
.c-flex-container .r {
  width: 90px;
  padding-left: 10px;
}
.c-errmsg {
  font-size: 14px;
  text-align: left;
  padding-top: 0px !important;
}
.le-tbs .c-select-community {
  width: 100%;
  padding: 0;
}

.le-tbs .c-community {
  position: absolute;
  top: 42px;
  left: 0px;
  width: 100%;
  padding: 0 24px;
}

.le-tbs .c-cover-area {
  flex-direction: column !important;
}
.le-tbs .c-img-item {
  left: 50%;
  transform: translateX(-50%);
  margin-top: -8px;
  margin-bottom: 8px;
}
.c-editor {
  padding-top: 0;
  padding-bottom: 16px;
}
.le-tbs .c-editor {
  margin-top: -8px;
}
.le-tbs .c-com-chip {
  margin-top: 24px;
}
.c-icon-area {
  position: relative;
  height: 10px;
}
.c-dlg-hd {
  width: 100%;
}
.le-tbs .c-dlg-hd {
  margin-bottom: -4px;
}
.c-dlg-ttl {
  font-size: 16px;
}
.c-dlg-icon {
  margin-right: 5px;
  margin-top: -2px;
}

.c-explain {
  margin-top: 2px;
  opacity: 0.8;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-bottom: 8px;
}
.le-tbs .c-explain {
  font-size: 14px;
}
.checks .v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
